export default __webpack_public_path__ + "static/media/womenCoatSkirt.f6225023.png";